"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySelector = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var c = (0, BemBuilder_1.default)("currency-selector");
var CurrencySelector = function (_a) {
    var label = _a.label, buttonClassName = _a.buttonClassName, popoverClassName = _a.popoverClassName, currentCurrency = _a.currentCurrency, locale = _a.locale, onChange = _a.onChange, disabled = _a.disabled, bottomElement = _a.bottomElement, iconOnly = _a.iconOnly, tooltipProps = _a.tooltipProps;
    var currenciesList = (0, inversify_react_1.useInjection)("currenciesList");
    var currencyMetadata = currenciesList.get(currentCurrency);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, label),
        react_1.default.createElement(kaleidoscope_1.Popover, { className: c("popover ".concat(popoverClassName)), autoStack: true, size: kaleidoscope_1.PopoverSize.Auto, caret: true, button: function (buttonProps) { return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    if (tooltipProps) {
                        return react_1.default.createElement(kaleidoscope_1.Tooltip, __assign({}, tooltipProps), children);
                    }
                } },
                react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: "".concat(c("button"), " ").concat(buttonClassName), type: kaleidoscope_1.ButtonType.Secondary, disabled: disabled, isIconOnly: iconOnly, isRound: iconOnly }, buttonProps),
                    react_1.default.createElement("img", { className: c("circle-flag"), src: currencyMetadata.flagImage }),
                    !iconOnly && currentCurrency,
                    !iconOnly && react_1.default.createElement(icons_1.ChevronDown, null)))); } },
            react_1.default.createElement(CurrencySelectorMenu, { currentCurrency: currentCurrency, currenciesList: currenciesList, locale: locale, onSelect: onChange, bottomElement: bottomElement }))));
};
exports.CurrencySelector = CurrencySelector;
var CurrencySelectorMenu = function (_a) {
    var currenciesList = _a.currenciesList, currentCurrency = _a.currentCurrency, locale = _a.locale, onSelect = _a.onSelect, bottomElement = _a.bottomElement;
    var _b = __read((0, react_1.useState)(""), 2), searchTerm = _b[0], setSearchTerm = _b[1];
    var currenciesMetadata = getCurrenciesMetadata(currenciesList, searchTerm);
    return (react_1.default.createElement("div", { className: c("menu") },
        react_1.default.createElement(kaleidoscope_1.SearchInput, { className: "".concat(c("search-input"), " space-stack-s"), label: "Currency search", onChange: setSearchTerm, value: searchTerm, placeholder: "Find currency", autoFocus: true }),
        react_1.default.createElement("div", { className: c("search-results") }, currenciesMetadata.map(function (currencyMetadata) {
            return (react_1.default.createElement(CurrencyCard, { key: currencyMetadata.code, currencyMetadata: currencyMetadata, locale: locale, selected: currencyMetadata.code === currentCurrency, onSelect: onSelect }));
        })),
        bottomElement));
};
var defaultCurrencyCodes = Object.freeze(["USD", "GBP", "AUD", "EUR", "JPY"]);
var currencySampleValue = 1000.12;
var CurrencyCard = function (_a) {
    var _b;
    var currencyMetadata = _a.currencyMetadata, locale = _a.locale, selected = _a.selected, onSelect = _a.onSelect;
    return (react_1.default.createElement("button", { className: (0, classnames_1.default)(c("currency-card"), "space-stack-xs", "button-mixin", (_b = {},
            _b[c("currency-card", "selected")] = selected,
            _b)), onClick: function () { return onSelect(currencyMetadata.code); } },
        react_1.default.createElement("div", { className: c("card-left") },
            react_1.default.createElement("img", { className: c("card-flag"), src: currencyMetadata.flagImage }),
            react_1.default.createElement(kaleidoscope_1.Label, null, currencyMetadata.code)),
        react_1.default.createElement("div", { className: c("card-right") },
            react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, (0, FormatCurrency_1.formatCurrency)(currencySampleValue, currencyMetadata.code, undefined, locale)),
            selected && react_1.default.createElement(icons_1.Tick, { color: "success", size: icons_1.IconSize.Small }))));
};
function getCurrenciesMetadata(currenciesList, searchTerm) {
    if (!searchTerm) {
        return defaultCurrencyCodes.map(function (code) {
            return currenciesList.get(code);
        });
    }
    return currenciesList.search(searchTerm, 5);
}
